import { getApiClient } from './authApiClient';

export const MERCURY_ASSISTANT_TENANT = '1KAV4fFiYOc3dPNCwzeT';
const segment = value => {
  if (typeof value !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(value) || ['constructor', 'prototype', '__proto__'].includes(value)) throw new Error('A valid saved report scope is required.');
  return encodeURIComponent(value);
};
const base = scope => {
  if (scope?.tenantId !== MERCURY_ASSISTANT_TENANT) throw new Error('The report assistant is unavailable for this account.');
  return `/financial-report-conversions/tenants/${segment(scope.tenantId)}/companies/${segment(scope.companyId)}/${segment(scope.reportId)}/assistant`;
};
const result = response => {
  if (response.data?.success !== true || response.data.data == null) throw new Error('The saved assistant response could not be confirmed.');
  return response.data.data;
};
export const listRequests = async (scope, options = {}) => result(await getApiClient('company').get(base(scope), { timeout: 15000, signal: options.signal }));
export const getRequest = async (scope, requestId, options = {}) => result(await getApiClient('company').get(`${base(scope)}/requests/${segment(requestId)}`, { timeout: 15000, signal: options.signal }));
const write = async (scope, suffix, body, options) => {
  const url = `${base(scope)}${suffix}`;
  // An uncertain write is recovered by a GET, never by auth-refresh replay.
  return result(await getApiClient('company').post(url, body, { timeout: 210000, signal: options?.signal, _retry: true }));
};
export const createDraft = (scope, body, options) => write(scope, '/drafts', body, options);
export const chat = (scope, body, options) => write(scope, '/chat', body, options);
export const cancel = (scope, requestId, options) => write(scope, `/requests/${segment(requestId)}/cancel`, {}, options);
